import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=ff6cc2b0&scoped=true&"
import script from "./FormView.vue?vue&type=script&lang=js&"
export * from "./FormView.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/FormView/FormView.less?vue&type=style&index=0&id=ff6cc2b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6cc2b0",
  null
  
)

export default component.exports